type SvgGradientProps = {
  gradient: string;
  id: string;
};
export const SvgGradient: React.FC<SvgGradientProps> = ({ gradient, id }) => {
  const stops = gradient
    .substring(gradient.indexOf('(') + 1, gradient.lastIndexOf(')'))
    .split(',')
    .slice(1);

  return (
    <linearGradient id={id}>
      {stops.map((stop, index) => {
        const [color, offSet] = stop.split(' ').slice(1);
        return <stop key={index} offset={offSet} stopColor={color} />;
      })}
    </linearGradient>
  );
};
